import {
  AviaLegTypes,
  GroundLegTypes,
  RouteLegType,
  RouteLegTypeEnum,
  SegmentTypeEnum,
  TmdxDriveAffiliateGroundLeg,
  TmdxDriveTedsGroundLeg,
} from '@/api/apis/route';
import { HOUR_IN_MS, MINUTE_IN_MS } from '@/constants/date.constants';
import { OrganType } from '@/api/apis/case';

export const AVIA_LEG_TYPES: RouteLegTypeEnum[] = [
  RouteLegTypeEnum.TmdxJetAviaLeg,
  RouteLegTypeEnum.SupplementalLiftAviaLeg,
  RouteLegTypeEnum.TxCenterProviderAviaLeg,
  RouteLegTypeEnum.CommercialFlightAviaLeg,
];

export const isAviaLegType = (leg: RouteLegType): leg is AviaLegTypes => AVIA_LEG_TYPES.includes(leg.legType);

const BASE_GROUND_LEG_TYPES: RouteLegTypeEnum[] = [
  RouteLegTypeEnum.TmdxAffiliateGroundLeg,
  RouteLegTypeEnum.TxCenterProviderGroundLeg,
  RouteLegTypeEnum.CurriServiceGroundLeg,
  RouteLegTypeEnum.SelfServicedGroundLeg,
];

const GROUND_TRIP_LEGS: RouteLegTypeEnum[] = [
  RouteLegTypeEnum.TmdxDriveAffiliateGroundLeg,
  RouteLegTypeEnum.TmdxDriveTedsGroundLeg,
];

export const GROUND_LEG_TYPES: RouteLegTypeEnum[] = [...BASE_GROUND_LEG_TYPES, ...GROUND_TRIP_LEGS];

export const isGroundLegType = (leg: RouteLegType): leg is GroundLegTypes => GROUND_LEG_TYPES.includes(leg.legType);
export const isBaseGroundLegType = (leg: RouteLegType): leg is GroundLegTypes =>
  BASE_GROUND_LEG_TYPES.includes(leg.legType);
export const isGroundTripLegType = (leg: RouteLegType): leg is TmdxDriveAffiliateGroundLeg | TmdxDriveTedsGroundLeg =>
  GROUND_TRIP_LEGS.includes(leg.legType);

export const REPOSITION_SEGMENT_TYPES = [SegmentTypeEnum.reposition, SegmentTypeEnum.returnToBase];

export const OPERATION_AT_HOSPITAL_DURATION_LIVER = 5 * HOUR_IN_MS;
export const OPERATION_AT_HOSPITAL_DURATION_HEART = 2 * HOUR_IN_MS;
export const OPERATION_AT_HOSPITAL_DURATION_LUNGS = 2 * HOUR_IN_MS;
export const OPERATION_AT_HOSPITAL_DURATION_KIDNEY = 4 * HOUR_IN_MS;

export const OPERATION_AT_TX_CENTER_DURATION = HOUR_IN_MS;

export const AIR_BLOCK_TIME = 12 * MINUTE_IN_MS;

export const OPERATION_TIME_BY_ORGAN: Record<OrganType, number> = {
  [OrganType.Heart]: OPERATION_AT_HOSPITAL_DURATION_HEART,
  [OrganType.Liver]: OPERATION_AT_HOSPITAL_DURATION_LIVER,
  [OrganType.Lungs]: OPERATION_AT_HOSPITAL_DURATION_LUNGS,
  [OrganType.Kidney]: OPERATION_AT_HOSPITAL_DURATION_KIDNEY,
};
